import ColorSelection from './ColorSelection';

export default ColorSelection;
